<template>
  <swiper ref="mySwiper" :class="$style.swiper" :options="swiperOption">
    <swiper-slide v-for="item in swiperList" :key="item.id" :class="$style['swiper-item']">
      <div
        id="backImg"
        :class="$style['back-image']"
        :style="{ backgroundImage: `url(${item.background})` }"
      >
        <img :src="downloadImg" alt />
      </div>
      <div :class="$style.info">
        <img :src="item.icon" alt />
        <div :class="$style.detail">
          <p>{{ item.name }}</p>
          <p>{{ item.remark }}</p>
        </div>
        <button id="pickGift">领取礼包</button>
      </div>
    </swiper-slide>
  </swiper>
</template>

<script>
let vm = ''
import { CDN_URL } from "@/config/index.js";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import { signPickGift } from '@/api/activity';
import 'swiper/css/swiper.css';
export default {
  name: 'SlideShow',
  props: {
    swiperList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      downloadImg: `${CDN_URL}/gameCenter/download.png`, // 下载小图标
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 3000, // 3秒切换一次
          disableOnInteraction: false,
        },
        on: {
          click(e) {
            let realIndex = this.realIndex;
            if (e.target.id == 'backImg') {
              vm.handleLinkTo(vm.swiperList[realIndex])
            }
            if (e.target.id == "pickGift") {
              vm.handleReceiveGift(vm.swiperList[realIndex])
            }
          }
        }
      },
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  computed: {
    swiperObj() {
      return this.$refs.mySwiper.$swiper
    }
  },
  directives: {
    swiper: directive
  },
  created() {
    vm = this
  },
  methods: {
    handleLinkTo(item) {
      window.open(item.url, "_self");
    },
    handleReceiveGift(item) {
      this.$bus.$emit('showGiftDialog', { type: 'noGameGift', gameUrl: item.url })
    }
  },
}
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
@import '~@/styles/_variable.scss';
// 轮播图
.swiper {
  width: 100%;
  height: 210px;
  .swiper-item {
    .back-image {
      position: relative;
      width: 100%;
      height: 155px;
      background-repeat: no-repeat;
      background-size: cover;
      > img {
        position: absolute;
        right: 7px;
        bottom: 9px;
        width: 70px;
        height: auto;
      }
    }
    .info {
      padding-top: 2px;
      padding-right: 7px;
      padding-bottom: 2px;
      width: 100%;
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      > img {
        width: 45px;
        height: 45px;
        border-radius: 7px;
      }
      .detail {
        margin-left: 6px;
        width: 210px;
        font-size: 11px;
        > p:first-child {
          @include ellipsis(1);
          line-height: 16px;
        }
        > p:last-child {
          @include ellipsis(1);
          line-height: 16px;
          color: rgba(159, 159, 159, 1);
        }
      }
      > button {
        @include clearBtnDefaultStyle;
        padding: 0;
        width: 70px;
        height: $buttonHeight;
        color: #fff;
        font-size: 10px;
        background-color: $buttonColor;
        border-radius: 15px;
      }
    }
  }
}
</style>
<style>
.swiper-pagination-bullet {
  background-color: #959595;
  opacity: 1;
  width: 6px;
  height: 6px;
}
.swiper-pagination-bullet-active {
  background-color: #ffd164;
  opacity: 1;
}
</style>
